import { useParams } from "react-router";
import { ActiveAlertsWidget } from "@gf-alerting/widgets";
import { TableWrapper, Wrapper } from "./ActiveAlertTab.styles";

export default function AlertHistoryTab() {
  const { deviceId } = useParams();

  return (
    <Wrapper>
      <TableWrapper>
        <ActiveAlertsWidget
          type="page"
          sourceId={deviceId as string}
          cellStyles={{ height: 48, minHeight: 48 }}
        />
      </TableWrapper>
    </Wrapper>
  );
}
